import { render, staticRenderFns } from "./ver.vue?vue&type=template&id=2f9401ec"
import script from "./ver.ts?vue&type=script&lang=js&external"
export * from "./ver.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9401ec')) {
      api.createRecord('2f9401ec', component.options)
    } else {
      api.reload('2f9401ec', component.options)
    }
    module.hot.accept("./ver.vue?vue&type=template&id=2f9401ec", function () {
      api.rerender('2f9401ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/historico/vendaHistorico/ver.vue"
export default component.exports